import { type SelectOption } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import locationsCollection from 'modules/locations/store/collections/locations'
import workAreasCollection from 'modules/locations/store/collections/workAreas'
import type WorkArea from 'modules/locations/store/models/WorkArea'
import { SYMBOLIC_MIXED_VALUE } from 'modules/shift_management/lib/types'

interface Props {
  locationField: Field
  mixedValuesLocation?: boolean
  mixedValuesWorkArea?: boolean
}

const useLocationOptions = ({ locationField, mixedValuesLocation, mixedValuesWorkArea }: Props) => {
  const locationOptions = useMemo<SelectOption[]>(() => {
    const options = locationsCollection.map((location) => ({
      label: location.attributes.name,
      value: location.attributes.id,
      disabled: false,
    }))

    if (mixedValuesLocation) {
      options.unshift({
        label: i18n.t('shift_management.edit_shifts.placeholder'),
        value: SYMBOLIC_MIXED_VALUE,
        disabled: false,
      })
    }

    return options
  }, [mixedValuesLocation])

  const workAreaOptions = useMemo<SelectOption[]>(() => {
    if (!locationField.value) {
      return [
        {
          label: '',
          value: '',
          disabled: true,
        },
      ]
    }

    const options = workAreasCollection
      .filter({
        location_id: parseInt(locationField.value),
        archived_at: null,
      })
      .map((workArea: WorkArea) => ({
        label: workArea.attributes.name,
        value: workArea.attributes.id,
        disabled: false,
      }))

    if (mixedValuesWorkArea && !locationField.isDirty) {
      options.unshift({
        label: i18n.t('shift_management.edit_shifts.placeholder'),
        value: SYMBOLIC_MIXED_VALUE,
        disabled: false,
      })
    }

    return options
  }, [locationField.value, locationField.isDirty, mixedValuesWorkArea])

  return {
    locationOptions,
    workAreaOptions,
  }
}

export default useLocationOptions
